import { render, staticRenderFns } from "./Productores.vue?vue&type=template&id=a96bbe08&scoped=true&"
import script from "./Productores.vue?vue&type=script&lang=js&"
export * from "./Productores.vue?vue&type=script&lang=js&"
import style0 from "./Productores.vue?vue&type=style&index=0&id=a96bbe08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96bbe08",
  null
  
)

export default component.exports